import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface ConsultationFormData {
  full_name: string;
  phone: string;
  email: string;
  case_type: string;
  description: string;
}

/**
 * Submit a consultation request to Supabase
 * @param formData - The consultation form data
 * @returns Success status and any error message
 */
export const submitConsultation = async (formData: ConsultationFormData) => {
  try {
    const { data, error } = await supabase
      .from('consultations')
      .insert([
        {
          full_name: formData.full_name,
          phone: formData.phone,
          email: formData.email,
          case_type: formData.case_type,
          description: formData.description,
          status: 'pending',
          // created_at is auto-generated by Supabase (default: now())
        },
      ])
      .select();

    if (error) {
      throw error;
    }

    return { success: true, data };
  } catch (error: any) {
    console.error('Error submitting consultation:', error);
    return { success: false, error: error.message };
  }
};